import React from "react";

const AboutMe = () => {
  return (
    <section className="p-10">
      <h2 className="text-4xl font-bold mb-5">About Me</h2>
      <p className="text-lg text-gray-700">
        I’m Rajeev Pandya, the Chief Human Resources Officer at Geetanjali Group of Colleges in Udaipur. With a strong background in HR management, I've spent over a decade building and leading teams across industries, helping organizations thrive through effective people management strategies.
        <br />
        <br />
        After completing my Master's in Human Resource Management from the University College of Commerce and Management Studies in Udaipur, I gained valuable experience during my internship at Cadila Pharmaceuticals. My career has since spanned leadership roles at Nirma Group, Gokul Group, and Shalby Hospitals, where I focused on optimizing HR practices, talent development, and organizational growth.
        <br />
        <br />
        I'm passionate about continuous learning and actively engage with professional organizations like the Indian Society for Training and Development (ISTD) and the Quality Control Forum of India (QCFI). In addition to my professional work, I enjoy motivational speaking, writing poetry, and playing the keyboard and flute in my free time.
        <br />
        <br />
        For me, success is driven by attitude, skill, and knowledge—with attitude being the most critical. I believe in creating environments where people can learn, grow, and succeed together.
      </p>
    </section>
  );
};

export default AboutMe;
